<template>
  <div class="profile-block">
    <div v-if="isLoggedIn" class="profile-block__wrapper">
      <div class="profile-block__top">
        <div class="profile-block__nickname">
          <UiText
            :text="$tc('burgerMenu.profileBlock.nickname')"
            font="body-caption"
            color="typography-body01"
            class="profile-block__title"
          />
          <UiText
            :text="user.name"
            font="body-text-small"
            color="typography-body02"
            class="profile-block__description"
          />
        </div>
        <div class="profile-block__user-id">
          <UiText
            text="User ID"
            font="body-caption"
            color="typography-body01"
            class="profile-block__title"
          />
          <div class="profile-block__description" @click="copyToClipboard">
            <UiText
              :text="user.id"
              font="body-text-small"
              color="typography-body02"
            />
            <SvgIcon
              name="navigation/copy-icon"
              class="profile-block__copy-icon"
            />
          </div>
        </div>
        <UiBtn
          color="default"
          icon="chevrons/chevron-right"
          :to="$paths.profile"
          class="profile-block__profile-button"
        />
      </div>
      <ClientOnly>
        <NotificationPanel
          v-if="isShowNotificationPanel"
          class="profile-block__notification"
        />
      </ClientOnly>
      <div class="profile-block__bottom">
        <div class="profile-block__pay-block">
          <div class="profile-block__pay-text">
            <UiText
              font="components-balance-card-title"
              color="typography-body01"
              :text="$tc('burgerMenu.profileBlock.balance')"
              class="profile-block__pay-title"
            />
            <UiText
              font="components-balance-card-number"
              color="typography-title01"
              :text="`${c_balance.balance} ₴`"
              class="profile-block__pay-description"
            />
          </div>
          <UiBtn
            color="primary"
            icon="navigation/plus"
            class="profile-block__pay-button"
            :to="$paths.cashbox"
          />
        </div>
        <div class="profile-block__pay-block">
          <div class="profile-block__pay-text">
            <UiText
              font="components-balance-card-title"
              color="typography-body01"
              :text="$tc('burgerMenu.profileBlock.payOut')"
              class="profile-block__pay-title"
            />
            <UiText
              font="components-balance-card-number"
              color="typography-title01"
              :text="`${c_balance.maxPayout} ₴`"
              class="profile-block__pay-description"
            />
          </div>
          <UiBtn
            color="gray"
            icon="navigation/minus"
            class="profile-block__pay-button"
            :to="$paths.cashboxWthdrawal"
          />
        </div>
      </div>
    </div>
    <div v-else class="profile-block__wrapper">
      <div class="profile-block__auth-text">
        <UiText
          font="body-text"
          color="typography-title01"
          class="profile-block__auth-title"
        >
          <SvgIcon
            name="navigation/shield-cross"
            class="profile-block__auth-icon"
          />
          <span>{{ $tc('burgerMenu.authBlock.title') }}</span>
        </UiText>
        <UiText
          :text="$tc('burgerMenu.authBlock.description')"
          font="body-caption"
          align-center
          color="typography-body01"
          class="profile-block__auth-description"
        />
        <div class="profile-block__auth-buttons">
          <UiBtn
            :text="$tc('burgerMenu.authBlock.login')"
            color="default"
            @click="openRegModal"
          />
          <UiBtn
            :text="$tc('burgerMenu.authBlock.registration')"
            color="primary"
            @click="openRegModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatNumberFilter } from '@/util/helpers/vueFilters'

export default {
  name: 'ProfileBlock',
  components: { NotificationPanel: () => import('@/components/NotificationPanel') },
  computed: {
    ...mapGetters('user', [
      'user',
      'isLoggedIn',
      'maxPayout',
      'balance',
      'isUserLoaded',
      'isUserVerified',
    ]),
    ...mapGetters('limits', ['get_limitsIsLoaded', 'get_isLimitsHasBeenSet']),
    isShowNotificationPanel() {
      if (!this.isUserLoaded || !this.get_limitsIsLoaded || !this.isLoggedIn) return false
      return !this.isUserVerified || !this.get_isLimitsHasBeenSet
    },
    c_balance() {
      return this.isUserLoaded
        ? {
          balance: formatNumberFilter(this.balance,{ format: 'currency' }),
          maxPayout: formatNumberFilter(this.maxPayout,{ format: 'currency' }),
        }
        : {
          balance: '--',
          maxPayout: '--',
        }
    },
  },
  methods: {
    ...mapActions('notifyToast', ['show_notify']),
    copyToClipboard() {
      navigator.clipboard.writeText(this.user.id)
      this.show_notify({
        text: this.$tc('profilePage.alertCopy'),
        type: 'success',
      })
    },
    openRegModal() {
      this.$newModal.openAuthWithLastMethod()
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
